import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import i18next from 'i18next';
import { StorageService } from 'src/app/core/storage/storage.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-request-completed',
  templateUrl: './request-completed.component.html',
  styleUrls: ['./request-completed.component.scss'],
  imports: [CommonModule, SharedModule]
})
export class RequestCompletedComponent implements OnInit {
  orderType: undefined | string;
  orderSubType: undefined | string;
  substitutionRequestNumber: undefined | string;

  constructor(
    private route: ActivatedRoute,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams['orderType']) this.orderType = queryParams['orderType'];
      if (queryParams['orderSubType'])
        this.orderSubType = queryParams['orderSubType'];
      if (queryParams['substitutionRequestNumber'])
        this.substitutionRequestNumber =
          queryParams['substitutionRequestNumber'];
    });

    this.storageService.set('substitutionVehicle', null);
    this.storageService.set('substitutionVin', null);
    this.storageService.set('substitutionRequestNumber', null);
  }

  translateOrderType() {
    if (this.orderType) {
      const key =
        'endowmentLeasing' +
        this.orderType.charAt(0).toUpperCase() +
        this.orderType.slice(1).replaceAll('_', '').toLowerCase();
      if (i18next.language.includes('es')) return i18next.t(key).toLowerCase();
      else return i18next.t(key);
    }
    return '';
  }
}
